import React from "react"

import TurborepoIcon from "@/assets/icons/dev-icons/TurborepoIcon"
import ReactIcon from "@/assets/icons/dev-icons/ReactIcon"
import SpringIcon from "@/assets/icons/dev-icons/SpringIcon"
import GitIcon from "@/assets/icons/dev-icons/GitIcon"
import FigmaIcon from "@/assets/icons/dev-icons/FigmaIcon"
import TsIcon from "@/assets/icons/dev-icons/TsIcon"
import JsIcon from "@/assets/icons/dev-icons/JsIcon"
import HtmlIcon from "@/assets/icons/dev-icons/HtmlIcon"
import CssIcon from "@/assets/icons/dev-icons/CssIcon"
import ScssIcon from "@/assets/icons/dev-icons/ScssIcon"
import JavaIcon from "@/assets/icons/dev-icons/JavaIcon"
import MySQLIcon from "@/assets/icons/dev-icons/MySQLIcon"
import TailwindIcon from "@/assets/icons/dev-icons/TailwindIcon"
import StyledComponentsIcon from "@/assets/icons/dev-icons/StyledComponentsIcon"
import BootstrapIcon from "@/assets/icons/dev-icons/BootstrapIcon"
import PostmanIcon from "@/assets/icons/dev-icons/PostmanIcon"
import VercelIcon from "@/assets/icons/dev-icons/VercelIcon"
import BiomeIcon from "@/assets/icons/dev-icons/BiomeIcon"
import NodeJSIcon from "@/assets/icons/dev-icons/NodeJSIcon"
import MavenIcon from "@/assets/icons/dev-icons/MavenIcon"
import MFEIcon from "@/assets/icons/dev-icons/MFEIcon"
import GithubIcon from "@/assets/icons/dev-icons/GithubIcon"
import NextJSIcon from "@/assets/icons/dev-icons/NextJSIcon"
import ReactNativeIcon from "@/assets/icons/dev-icons/ReactNativeIcon"
import LessJSIcon from "@/assets/icons/dev-icons/LessJSIcon"
import ViteIcon from "@/assets/icons/dev-icons/ViteIcon"
import AngularIcon from "@/assets/icons/dev-icons/AngularIcon"
import ReactNavigationIcon from "@/assets/icons/dev-icons/ReactNavigationIcon"
import {LExpressImg} from "@/assets/imgs/export";
import ExpressIcon from "@/assets/icons/ExpressIcon";
import ExpoIcon from "@/assets/icons/ExpoIcon";

export const skillsIcons: Record<string, React.FC> = {
	React: ReactIcon,
	Spring: SpringIcon,
	Git: GitIcon,
	Figma: FigmaIcon,
	TypeScript: TsIcon,
	JavaScript: JsIcon,
	HTML: HtmlIcon,
	CSS: CssIcon,
	SCSS: ScssIcon,
	NextJS: NextJSIcon,
	Java: JavaIcon,
	MySQL: MySQLIcon,
	TailwindCSS: TailwindIcon,
	"styled-components": StyledComponentsIcon,
	Bootstrap: BootstrapIcon,
	Vite: ViteIcon,
	Express: ExpressIcon,
	ExpoIcon: ExpoIcon,
	Postman: PostmanIcon,
	Angular: AngularIcon,
	Vercel: VercelIcon,
	BiomeJS: BiomeIcon,
	NodeJS: NodeJSIcon,
	Maven: MavenIcon,
	ReactNative: ReactNativeIcon,
	"module-federation": MFEIcon,
	Turborepo: TurborepoIcon,
	lessJS: LessJSIcon,
	Github: GithubIcon,
	ReactNavigation: ReactNavigationIcon,
}
